import React, { Component } from 'react';
import PropTypes from 'prop-types';
import request from '@host-panel/request';
import socialLoginAction from '../../actions/account/social-login';
import Icon from 'utils/components/icon';
import { getNetworkIdInjectorValue } from '@spotim/fed-common';
import { socialLogin } from '@spotim/fed-social-login/src/social-login';
import { getNetwork, getSpotId, getToken } from 'app/scripts/services/app-state';
import { syncCurrentUserToRedux } from 'state/helpers/syncHelpers';

const displayName = 'SocialConnect';

class SocialConnect extends Component {
  async connect(socialNetwork) {
    var networkId = getNetworkIdInjectorValue();
    let token = getToken();
    await socialLogin(socialNetwork, token, null, { networkId });
    var response = await request('/login-registered', {
      method: 'POST',
      service: 'me',
      data: {
        spot_id: getSpotId()
      },
      headers: { 'x-spotim-token': getToken(), 'x-spotim-networkid': getNetwork().id },
      addJWTtoLocalStorage: true
    });
    this.context.executeAction(socialLoginAction, response);
    syncCurrentUserToRedux(response);
  }

  render() {
    const { titleText, isGoogleConnectDisabled, isTwitterConnectDisabled } = this.props;

    return (
      <div className="social-connect">
        <h6 className="connect-title">{titleText}</h6>
        <div className="logos">
          {/* <a
            className="connect-wrapper facebook-wrapper"
            href="javascript:void(0)"
            onClick={this.connect.bind(this, 'facebook')}
          >
            <Icon name="facebook-connect" className="facebook" />
          </a> */}
          {!isTwitterConnectDisabled && (
            <a
              className="connect-wrapper twitter-wrapper"
              onClick={this.connect.bind(this, 'twitter')}
            >
              <Icon name="twitter-connect" className="twitter" />
            </a>
          )}
          {!isGoogleConnectDisabled && (
            <a
              className="connect-wrapper google-wrapper"
              onClick={this.connect.bind(this, 'google')}
            >
              <Icon name="google-connect" className="google" />
            </a>
          )}
        </div>
      </div>
    );
  }
}

SocialConnect.defaultProps = {
  titleText: 'You can also connect with:',
  isGoogleConnectDisabled: false,
  isTwitterConnectDisabled: false
};

SocialConnect.propTypes = {
  titleText: PropTypes.string,
  isGoogleConnectDisabled: PropTypes.bool,
  isTwitterConnectDisabled: PropTypes.bool
};

SocialConnect.contextTypes = {
  executeAction: PropTypes.func.isRequired
};

SocialConnect.displayName = displayName;

export default SocialConnect;
